import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { CurrencyFilters } from '../../../commons/models/currency.model';

@Component({
  selector: 'app-currency-filters',
  templateUrl: './currency-filters.component.html',
  styleUrls: ['./currency-filters.component.scss']
})
export class CurrencyFiltersComponent {


  @Output()
  onFilter: EventEmitter<CurrencyFilters> = new EventEmitter();

  private _defaultFilters: CurrencyFilters;
  filtersForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this._createForm();
  }

  private _createForm() {
    let group = {
      search: "",
    }

    this.filtersForm = this.fb.group(group);
  }

  applyFilters() {
    this.onFilter.emit(this._getCurrencyFilters());
  }

  private _getCurrencyFilters(): CurrencyFilters {
    let filters: CurrencyFilters = {}
    if (this.filtersForm) {
      const values = this.filtersForm.value;
      filters.search = values.search;
    }
    return filters;
  }

  resetFilters() {
    this.filtersForm.reset();
    this.filtersForm.patchValue({
      search: "",
    });
    this._setDefaultValues();
    this.applyFilters();
  }

  get defaultFilters(): CurrencyFilters {
    return this._defaultFilters;
  }

  @Input()
  set defaultFilters(defaultFilters: CurrencyFilters) {
    this._defaultFilters = defaultFilters;
    this._setDefaultValues();
  }

  private _setDefaultValues() {
    if (this.defaultFilters) {
      if (this.filtersForm) {
        this.filtersForm.patchValue({
          search: this.defaultFilters.search,
        })
      }
    }
  }
}
